import { PaymentStatus } from '@domain/models';

export type PaymentStatusTone = 'ok' | 'warning' | 'rejected' | 'error';

export interface PaymentStatusUi {
  tone: PaymentStatusTone;
  label: string;
}

export function getPaymentStatusUi(status: PaymentStatus): PaymentStatusUi {
  switch (status) {
    case 'VALIDATED':
      return {
        tone: 'ok',
        label: 'Validada'
      };
    case 'DUPLICATED':
      return {
        tone: 'rejected',
        label: 'Duplicado'
      };
    case 'NOT_FOUND':
      return {
        tone: 'rejected',
        label: 'No encontrado'
      };
    case 'DATE_EXPIRED':
      return {
        tone: 'rejected',
        label: 'Fecha vencida'
      };
    case 'NON_PAYMENT_IMAGE':
      return {
        tone: 'rejected',
        label: 'No es pago'
      };
    case 'CHANNEL_NOT_ALLOWED':
      return {
        tone: 'rejected',
        label: 'Canal no habilitado'
      };
    case 'MANUAL_REVIEW_REQUIRED':
      return {
        tone: 'warning',
        label: 'Revisión manual'
      };
    case 'USER_CONFIRMATION_REQUIRED':
      return {
        tone: 'warning',
        label: 'Confirmación'
      };
    case 'ERROR_AGENT':
      return {
        tone: 'error',
        label: 'Error de análisis'
      };
    case 'ERROR_PROCESSOR':
      return {
        tone: 'error',
        label: 'Error de validación'
      };
  }
}
